import type { Prettify } from '../../../../lib/typeUtils';
import type { Dimensions, Padding, Rectangle2D } from '../utils';

export type CanvasTransform = {
  zoom: number;
  translateX: number;
  translateY: number;
};

// Each is important for one transition boundary
export type CoordinateTransformContext = {
  viewportRect: Rectangle2D; // screen <-> viewport
  canvasTransform: CanvasTransform; // viewport <-> canvas
  contentPadding: Padding; // canvas <-> content
};

export type CanvasContext = Prettify<
  CoordinateTransformContext & {
    contentDimensions: Dimensions;
  }
>;

export const getCoordinateTransformContext = <
  T extends {
    viewportRect: Rectangle2D;
    padding: Padding;
    transform: CanvasTransform;
  },
>(
  source: T
): CoordinateTransformContext => ({
  viewportRect: source.viewportRect,
  contentPadding: source.padding,
  canvasTransform: source.transform,
});
